shadow$provide[249] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Strip:{enumerable:true, get:function() {
  return Strip;
}}});
var UGLSL = require("../../../util/glsl.js");
var UJS = require("../../../util/js.js");
var require$_DOT__DOT__SLASH__DOT__DOT__SLASH_primitive_DOT_js = require("../../primitive.js");
class Strip extends require$_DOT__DOT__SLASH__DOT__DOT__SLASH_primitive_DOT_js.Primitive {
  static initClass() {
    this.traits = ["node", "object", "visible", "style", "line", "mesh", "strip", "geometry", "position", "bind", "shade",];
  }
  constructor(node, context, helpers) {
    super(node, context, helpers);
    this.strip = null;
  }
  resize() {
    if (this.bind.points == null) {
      return;
    }
    const dims = this.bind.points.getActiveDimensions();
    const {items, width, height, depth} = dims;
    if (this.strip) {
      this.strip.geometry.clip(width, height, depth, items);
    }
    if (this.line) {
      this.line.geometry.clip(items, width, height, depth);
    }
    if (this.bind.map != null) {
      const map = this.bind.map.getActiveDimensions();
      if (this.strip) {
        return this.strip.geometry.map(map.width, map.height, map.depth, map.items);
      }
    }
  }
  make() {
    let color, uniforms;
    this._helpers.bind.make([{to:"geometry.points", trait:"source"}, {to:"geometry.colors", trait:"source"}, {to:"mesh.map", trait:"source"},]);
    if (this.bind.points == null) {
      return;
    }
    let position = this._shaders.shader();
    position = this.bind.points.sourceShader(position);
    position = this._helpers.position.pipeline(position);
    const styleUniforms = this._helpers.style.uniforms();
    const lineUniforms = this._helpers.line.uniforms();
    const unitUniforms = this._inherit("unit").getUnitUniforms();
    const {line, shaded, fill, stroke, join} = this.props;
    const wireUniforms = {};
    wireUniforms.styleZBias = this._attributes.make(this._types.number());
    this.wireZBias = wireUniforms.styleZBias;
    const dims = this.bind.points.getDimensions();
    const {items, width, height, depth} = dims;
    if (this.bind.colors) {
      color = this._shaders.shader();
      color = this.bind.colors.sourceShader(color);
    }
    const mask = this._helpers.object.mask();
    this._helpers.shade.map(this.bind.map != null ? this.bind.map.sourceShader(this._shaders.shader()) : undefined);
    const material = this._helpers.shade.pipeline();
    const faceMaterial = material || shaded;
    const lineMaterial = material || false;
    const objects = [];
    if (line) {
      const swizzle = this._shaders.shader();
      swizzle.pipe(UGLSL.swizzleVec4("yzwx"));
      swizzle.pipe(position);
      uniforms = UJS.merge(unitUniforms, lineUniforms, styleUniforms, wireUniforms);
      this.line = this._renderables.make("line", {uniforms, samples:items, strips:width, ribbons:height, layers:depth, position:swizzle, color, stroke, join, mask, material:lineMaterial,});
      objects.push(this.line);
    }
    if (fill) {
      uniforms = UJS.merge(styleUniforms, {});
      this.strip = this._renderables.make("strip", {uniforms, width, height, depth, items, position, color, material:faceMaterial,});
      objects.push(this.strip);
    }
    this._helpers.visible.make();
    return this._helpers.object.make(objects);
  }
  made() {
    return this.resize();
  }
  unmake() {
    this._helpers.bind.unmake();
    this._helpers.visible.unmake();
    this._helpers.object.unmake();
    return this.strip = null;
  }
  change(changed, touched, init) {
    if (changed["geometry.points"] || touched["mesh"]) {
      return this.rebuild();
    }
    if (changed["style.zBias"] || changed["mesh.lineBias"] || init) {
      const {fill, zBias, lineBias} = this.props;
      return this.wireZBias.value = zBias + (fill ? lineBias : 0);
    }
  }
}
Strip.initClass();

};